import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function HotelRegistration_step_1({ register, errors, setValue }) {
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    setValue("role_id", 3);
  }, [setValue]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <h5 className="step-heading">A. Account & Verification</h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <input type="hidden" {...register("role_id", { required: true })} />

            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                placeholder="Enter Name"
                {...register("name", {
                  required: "Name is required",
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.name && (
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Professional Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Professional Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors?.email && (
                <Form.Text className="text-danger">
                  {errors?.email?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Main Phone Number</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Main Phone Number"
                maxLength={10}
                {...register("contact_no", {
                  required: "Mobile Phone Number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                isInvalid={!!errors?.contact_no}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.contact_no?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <div
                className="password-input-container"
                style={{ position: "relative" }}
              >
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                  })}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "18px",
                    zIndex: 10,
                  }}
                  className="text-muted"
                />
              </div>
              {errors?.password && (
                <Form.Text className="text-danger">
                  {errors.password.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Control value="Hotel" disabled />
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelRegistration_step_1;
